import { clamp, isNotNumber, isNumber } from '../../../util/numbers';
import { isEmpty as isEmptyObject, isNotNil } from '../../../util/object';

import { AUDIBLE_MEDIA_TYPES } from '../../../constants';

/**
 * Determine if a medium has audio based on type and if there is a server id but
 * only if the server audio has been processed
 *
 * @param {String} mediaType
 * @param {String} audioServerId
 * @param {boolean} processedAudio
 * @returns {boolean}
 */
export const hasAudio = (mediaType, audioServerId, processedAudio) => {
  const validAudibleMedium = AUDIBLE_MEDIA_TYPES.has(mediaType);
  const hasAudio = !processedAudio || isNotNil(audioServerId);

  return Boolean(validAudibleMedium && hasAudio);
};

export const isMediumScalable = (media) => {
  return (
    isNotNil(media) &&
    isNumber(media.height) &&
    isNumber(media.width) &&
    media.height > 0 &&
    media.width > 0
  );
};

/**
 * For media centered in some container, get the relative additive transform that will
 * align the media to the most salient center.
 * @param {Medium} media
 * @param {Number} mediaScale the scale of the original media used to put the image in the container
 * @param {Number} containerWidth  width of the image container in px
 */
export const getXTransformForCentering = (
  media,
  mediaScale,
  containerWidth,
) => {
  if (isEmptyObject(media) || isNotNumber(media.centerX)) return 0;

  const { centerX } = media;
  const containerScaleMultiplier = containerWidth / mediaScale;
  const transformX = clamp(
    centerX,
    containerScaleMultiplier / 2,
    media.width - containerScaleMultiplier / 2,
  );
  return Math.round(-1 * (transformX - media.width / 2) * mediaScale);
};
